import { useEffect, useState, useContext, useMemo, useRef } from "react";
import { IconPencil, IconTrash } from "@tabler/icons-react";
import { getDonationTPApi } from "../../Api/DonationTypePurpose";
import { transactionStatusApi } from "../../Api/Donation";
import { donateApi } from "../../Api/Donation";
import Cookies from "universal-cookie";
import { ThemeContext } from "../theme/ThemeProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../hooks/Redux/Redux";
import { getAllFeeByUserIdApi } from "../../Api/Fee";
import { fetchDonationTypeApi } from "../../Api/DonationTypes";
import { fetchPurposeApi } from "../../Api/DonationPurpose";
import UpdateUserDetails from "../../common/useraccount/UpdateUserDetails";

interface DonationModalProps {
  URL: string;
}

const DonationModal = ({ URL }: DonationModalProps) => {
  const cookies = useMemo(() => new Cookies(), []);
  const token = cookies.get("authToken");
  const location = useLocation();
  const { selectedFee } = location.state || {};

  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const themeContext = useContext(ThemeContext);
  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider ");
  }
  const { isDarkMode } = themeContext;

  type Donation = {
    id: string | null;
    typeId: string;
    type: string;
    amount: number;
    purposeId: string;
    purpose: string;
    onBehalfof: string;
    onBehalfofName: string;
    fee: Fee;
  };

  interface Fee {
    amount: number;
    studentId: string;
    typeId: string;
    courseOfferingId: string;
    payingTill?: string;
  }
  interface Option {
    id: string;
    name: string;
    label: string;
    isHiddenForUser: boolean;
  }

  interface DonationTypePurpose {
    id: string;
    donationTypeId: string;
    donationPurposeId: string;
    purposeid: string;
    label: string;
  }

  type Fees = {
    id: string;
    amount: number;
    courseOfferingId: string;
    userId: string;
    userName: string;
    course: string;
    courseType: string;
    durationType: string;
    type: string;
    feeFor: string;
    paidOn?: string | null;
    paidTill?: string | null;
  };

  const [donations, setDonations] = useState<Donation[]>([]);
  const [donationTypeOptions, setDonationTypeOptions] = useState<Option[]>([]);
  const [purposeOptions, setPurposeOptions] = useState<Option[]>([]);
  const [donationType, setDonationType] = useState<Option | null>(null) as any;
  const [donationPurpose, setDonationPurpose] = useState<Option | null>(
    null
  ) as any;
  const [donationAmount, setDonationAmount] = useState(0);
  const [onBehalfof, setOnBehalfof] = useState("Self");
  const [onBehalfofName, setOnBehalfofName] = useState("");
  const [donationTP, setDonationTP] = useState<DonationTypePurpose[]>([]);
  const [feeDetails, setFeeDetails] = useState<Fees[]>([]);
  const [selectedFeeData, setSelectedFeeData] = useState<any>();
  const [payCount, setPayCount] = useState<number>(1);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [modal, setmodal] = useState(false);
  const userProfile = useAppSelector((state) => state.userProfile.userData);

  const [detailsMissing, setDetailsMissing] = useState(false);

  const DEFAULT_DONATION_TYPE_NAME = "Normal / Sadaqah Nafilah";

  const url = process.env.REACT_APP_API_URL;

  const handleCancelClick = () => {
    setDetailsMissing(false);
  };
  const processedFeesRef = useRef(false);


  useEffect(() => {
    if (!URL) return;
    
    const fetchAllTypePurpose = async () => {
      try {
        const [typeResponse, purposeResponse, fetchDonationTypePurpose] = await Promise.all([
          fetchDonationTypeApi(URL),
          fetchPurposeApi(URL),
          getDonationTPApi("donationTPId", URL),
        ]);
        // console.log("typeResponse", typeResponse);
        // console.log("purposeResponse", purposeResponse);

        const FeeResponce = await getAllFeeByUserIdApi(url) as Fees[];
        setFeeDetails(FeeResponce);
        // console.log("FeeResponce", FeeResponce);

        // Filter typeResponse based on fetchDonationTypePurpose
        const filteredTypes = typeResponse.filter((type) =>
          fetchDonationTypePurpose.some((tp) => tp.donationTypeId === type.id)
        );
        // console.log("filteredTypes", filteredTypes);

        // Filter purposeResponse based on fetchDonationTypePurpose
        const filteredPurposes = purposeResponse.filter((purpose) =>
          fetchDonationTypePurpose.some((tp) => tp.donationPurposeId === purpose.id)
        );
        // console.log("filteredPurposes", filteredPurposes);

        setDonationTypeOptions(filteredTypes);
        setPurposeOptions(filteredPurposes);
        setDonationTP(fetchDonationTypePurpose);
        setIsDataLoaded(true);

      } catch (error) {
        console.error("Error fetching taxonomies:", error);
        console.error("Failed to load donation types and purposes");
      }
    };

    fetchAllTypePurpose();
  }, [URL, url]);

  useEffect(() => {
    // Reset processedFeesRef when navigating back to this page
    processedFeesRef.current = false;
  }, []); // Runs only on component mount

  useEffect(() => {
    if (
      processedFeesRef.current ||
      !selectedFee ||
      selectedFee.length === 0 ||
      donationTypeOptions.length === 0 ||
      purposeOptions.length === 0
    ) {
      console.log("Data not fully loaded or already processed. Skipping setFees.");
      return;
    }

    const normalType = donationTypeOptions.find(type => type.name === "Fees");
    const normalPurpose = purposeOptions.find(purpose => purpose.name === "Online Classes");

    if (!normalType || !normalPurpose) {
      console.error("Required donation type or purpose not found.");
      return;
    }

    // console.log("Setting donations based on selected fees:", selectedFee);
    const newDonations = selectedFee.map((fee) => ({
      id: null,
      typeId: normalType.id,
      type: normalType.name,
      purposeId: normalPurpose.id,
      purpose: normalPurpose.name,
      amount: fee.amount,
      onBehalfof: fee.feeFor,
      onBehalfofName: fee.feeFor === "Others" ? fee.userName : "",
      courseName: fee.courseName,
      courseType: fee.courseType,
      fee: {
        amount: fee.amount,
        studentId: fee.userId,
        typeId: fee.id,
        courseOfferingId: fee.courseOfferingId,
      },
    }));

    setDonations(newDonations);
    // console.log("Donation data set:", newDonations);

    processedFeesRef.current = true; // Mark as processed to prevent re-execution
  }, [selectedFee, donationTypeOptions, purposeOptions]); // Ensure it runs when these values update
  const donationOptions = donationTypeOptions.map((DonationType) => ({
    value: DonationType.name,
    id: DonationType.id,
    label: DonationType.name,
    isHiddenForUser: DonationType.isHiddenForUser
  }));

  const donationPurposeOptions = purposeOptions?.map((DonationPurpose) => ({
    value: DonationPurpose.name,
    id: DonationPurpose.id,
    label: DonationPurpose.name,
    isHiddenForUser: DonationPurpose.isHiddenForUser
  }));

  const getPurposesByDonationType = (typeId?: string) => {
    if (!typeId) {
      return [];
    }

    const filteredPurposes = donationTP
      .filter((dtp: any) => dtp.donationTypeId === typeId)
      .map((donationtp: any) => {
        const taxonomyPurpose = donationPurposeOptions.find(
          (purpose) => purpose.id === donationtp.donationPurposeId
        );

        if (!taxonomyPurpose) {
          return undefined;
        }

        return {
          value: taxonomyPurpose.value,
          id: donationtp.donationPurposeId,
          label: taxonomyPurpose.value,
          isHiddenForUser: taxonomyPurpose.isHiddenForUser,
        };
      })
      .filter(
        (
          item
        ): item is {
          value: string;
          id: string;
          label: string;
          isHiddenForUser: boolean;
        } => item !== undefined && item.isHiddenForUser !== true
      );

    const anyPurposes = filteredPurposes.filter(
      (purpose) => purpose.value?.trim().toLowerCase() === "any"
    );
    const otherPurposes = filteredPurposes.filter(
      (purpose) => purpose.value?.trim().toLowerCase() !== "any"
    );

    return [...anyPurposes, ...otherPurposes];
  };

  const getDefaultPurposeForType = (typeId?: string) => {
    const filteredPurposes = getPurposesByDonationType(typeId);
    if (filteredPurposes.length === 0) {
      return null;
    }

    const anyPurpose = filteredPurposes.find(
      (purpose) => purpose.value?.trim().toLowerCase() === "any"
    );

    return anyPurpose || filteredPurposes[0];
  };

  useEffect(() => {
    if (
      !modal ||
      editingIndex !== null ||
      donationType ||
      donationOptions.length === 0
    ) {
      return;
    }

    const defaultType =
      donationOptions.find(
        (option) => option.value === DEFAULT_DONATION_TYPE_NAME
      ) ||
      donationOptions.find(
        (option) => option.value?.trim().toLowerCase() === "normal / sadaqah nafilah"
      ) ||
      donationOptions[0];

    if (!defaultType) {
      return;
    }

    setDonationType(defaultType);
    setDonationPurpose(getDefaultPurposeForType(defaultType.id));
  }, [
    modal,
    editingIndex,
    donationType,
    donationOptions,
    donationTP,
    purposeOptions,
  ]);

  function handleResetForm() {
    setDonationType(null);
    setDonationAmount(0);
    setDonationPurpose(null);
    setOnBehalfof("Self");
    setOnBehalfofName("");
    setmodal(false);
    setSelectedFeeData(null);
    setPayCount(1);
  }
  function handleSubmitClick(e: React.FormEvent) {
    e.preventDefault();

    if (
      !donationAmount ||
      donationAmount <= 0 ||
      !donationPurpose ||
      !donationType
    ) {
      alert("Please fill all the fields");
      return;
    }

    if (onBehalfof === "Others" && !onBehalfofName) {
      alert("Please enter name for Others");
      return;
    }

    const donationData = {
      id: editingIndex !== null ? donations[editingIndex].id : null,
      typeId: donationType.id,
      type: donationType.value,
      purposeId: donationPurpose.id,
      purpose: donationPurpose.value,
      amount: donationAmount,
      onBehalfof: onBehalfof,
      onBehalfofName: onBehalfof === "Others" ? onBehalfofName : "",
      regId: selectedFeeData?.id || null,
      fee: {
        amount: selectedFeeData?.amount,
        studentId: selectedFeeData?.userId,
        typeId: selectedFeeData?.id,
        courseOfferingId: selectedFeeData?.courseOfferingId,
        payingTill: payingTill || selectedFeeData?.paidTill,
      }
    };

    if (editingIndex !== null) {
      const updatedDonations = [...donations];
      updatedDonations[editingIndex] = donationData;
      setDonations(updatedDonations);
      setEditingIndex(null);
      setmodal(false);
    } else {
      setDonations([...donations, donationData]);
    }

    handleResetForm();
    setmodal(false);
  }
  const handleEditClick = (index: number) => {
    const donationToEdit = donations[index];

    if (!isDataLoaded) {
      console.error("Please wait while data is loading...");
      return;
    }

    const matchedType = donationTypeOptions.find(
      (option) => option.id === donationToEdit.typeId
    );

    const matchedPurpose = purposeOptions.find(
      (option) => option.id === donationToEdit.purposeId
    );

    if (!matchedType || !matchedPurpose) {
      console.error("Could not find matching type or purpose", {
        typeId: donationToEdit.typeId,
        purposeId: donationToEdit.purposeId,
        availableTypes: donationTypeOptions,
        availablePurposes: purposeOptions,
      });
      console.error("Error loading donation details");
      return;
    }

    const updates = () => {
      setEditingIndex(index);
      setmodal(true);
      setDonationType({
        value: matchedType.name,
        id: matchedType.id,
        label: matchedType.name,
      });
      setDonationPurpose({
        value: matchedPurpose.name,
        id: matchedPurpose.id,
        label: matchedPurpose.name,
      });
      setDonationAmount(donationToEdit.amount);

      setOnBehalfof(donationToEdit.onBehalfof);
      setOnBehalfofName(donationToEdit.onBehalfofName || "");
      if (donationToEdit.typeId) {
        const foundFee = feeDetails.find((fee) => fee.id === donationToEdit.fee.typeId);
        setSelectedFeeData(foundFee || null);
      }
    };

    updates();
    setmodal(true);
  };
  const renderEditButton = (index: number) => (
    <IconPencil
      className={` ml-2 cursor-pointer ${isDarkMode ? " text-gray-300" : "text-black"
        }`}
      onClick={() => handleEditClick(index)}
    />
  );

  const donationEzpay = async () => {
    const details = donations.map((donation) => {
      const fee = donation.fee; 
      const hasValidFee =
        fee &&
        (fee.amount !== undefined ||
          fee.typeId !== undefined ||
          fee.studentId !== undefined ||
          fee.courseOfferingId !== undefined);

      return {
        amount: donation.amount,
        donationTypeId: donation.typeId,
        donationPurposeId: donation.purposeId,
        fee: hasValidFee ? fee : null,
        onBehalfOf: donation.onBehalfofName,
      };
    });
    const transactionType = 1;
    const response = await donateApi(
      totalAmount,
      details,
      token,
      transactionType
    );

    window.location.href = response.data[0];
  };


  const totalAmount = donations.reduce(
    (sum, donation) => sum + Number(donation.amount || 0),
    0
  );

  useEffect(() => {
    const checkTransactionStatus = async () => {
      try {

        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("donationId");
        if (!id) return;
        let localId = localStorage.getItem("donationId");
        let res = await transactionStatusApi(id as string);

        if (res === "E000" && id !== localId) {
          cookies.get("donations");
          cookies.remove("donations");
          localStorage.setItem("donationId", id as string);

          const savedDonations = cookies.get("donations");
          if (savedDonations) {
            setDonations(savedDonations);
          }
        } else {
          const savedDonations = cookies.get("donations");
          if (savedDonations) {
            setDonations(savedDonations);
          }
        }
      } catch (error) {
        const savedDonations = cookies.get("donations");
        if (savedDonations) {
          setDonations(savedDonations);
        }
      }
    };
    checkTransactionStatus();
  }, [cookies]);

  const navigate = useNavigate();

  const handleAddDonationClick = () => {
    if (!token) {
      navigate("/login");
    } else {
      if (!userProfile?.name || !userProfile?.mobile || !userProfile?.address) {
        setDetailsMissing(true);
      } else {
        setmodal(true);
      }
    }
  };

  function handleSelectFee(value: string): void {
    // Try to find in feeDetails first
    let fee = feeDetails.find((fee) => fee.id === value);
    // console.log("Selected Fee:", fee);

    // If found in feeDetails
    if (fee) {
      setSelectedFeeData(fee);
      setDonationAmount(fee.amount);
      setOnBehalfof(fee.feeFor);
      setOnBehalfofName(fee.userName);
    }
  }
  const handleSelectPayCount = (value: string) => {
    const count = Number(value);
    if (!isNaN(count) && count >= 1 && count <= 6) {
      setPayCount(count);
      if (selectedFeeData && selectedFeeData.amount) {
        setDonationAmount(selectedFeeData.amount * count);
      }
    } else {
      setPayCount(1);
      if (selectedFeeData && selectedFeeData.amount) {
        setDonationAmount(selectedFeeData.amount);
      }
    }
  };


  function getPayingTill(start: string | null | undefined, durationType: string, payCount: number) {
    if (!start) return "";
    const date = new Date(start);
    if (durationType === "Monthly") {
      date.setMonth(date.getMonth() + payCount);
    } else if (durationType === "Yearly") {
      date.setFullYear(date.getFullYear() + payCount);
    }
    return date.toISOString();
  }

  function formatDate(dateString: string | null | undefined) {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    // Get ordinal suffix
    const getOrdinal = (n: number) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  }

  const [payingFrom, setPayingFrom] = useState<string>("");
  const [payingTill, setPayingTill] = useState<string>("");

  // Update these when selectedFeeData changes
  useEffect(() => {
    if (selectedFeeData) {
      const fromDate = selectedFeeData.paidTill || new Date().toISOString().slice(0, 10);
      setPayingFrom(fromDate);

      // Default paying till: 1 month/year after fromDate
      const from = new Date(fromDate);
      if (!isNaN(from.getTime())) {
        if (selectedFeeData.durationType === "Monthly") {
          from.setMonth(from.getMonth() + 1);
        } else if (selectedFeeData.durationType === "Yearly") {
          from.setFullYear(from.getFullYear() + 1);
        }
        setPayingTill(from.toISOString().slice(0, 10));
      }
    }
  }, [selectedFeeData]);

  // Calculate months/years difference
  function getDurationCount(from: string, till: string, type: string) {
    const d1 = new Date(from);
    const d2 = new Date(till);
    if (type === "Monthly") {
      return (
        (d2.getFullYear() - d1.getFullYear()) * 12 +
        (d2.getMonth() - d1.getMonth()) +
        (d2.getDate() >= d1.getDate() ? 1 : 0)
      );
    } else if (type === "Yearly") {
      return (
        d2.getFullYear() - d1.getFullYear() +
        (d2.getMonth() > d1.getMonth() || (d2.getMonth() === d1.getMonth() && d2.getDate() >= d1.getDate()) ? 1 : 0)
      );
    }
    return 1;
  }

  // Replace getDurationCount with getProRataAmount
  function getProRataAmount(from: string, till: string, type: string, amount: number) {
    const d1 = new Date(from);
    const d2 = new Date(till);
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return 0;

    if (type === "Monthly") {
      // Calculate full months
      let months =
        (d2.getFullYear() - d1.getFullYear()) * 12 +
        (d2.getMonth() - d1.getMonth());

      // Anchor date for last full month
      const anchor = new Date(d1);
      anchor.setMonth(anchor.getMonth() + months);

      let total = months * amount;

      // If d2 is after anchor, add pro-rata for extra days
      if (d2 > anchor) {
        const extraDays = (d2.getTime() - anchor.getTime()) / (1000 * 60 * 60 * 24);
        total += Math.round((amount / 30) * extraDays);
      }
      // If d2 is exactly anchor (same day), do nothing extra (already counted in months)
      return total;
    } else if (type === "Yearly") {
      let years = d2.getFullYear() - d1.getFullYear();
      const anchor = new Date(d1);
      anchor.setFullYear(anchor.getFullYear() + years);

      let total = years * amount;

      if (d2 > anchor) {
        const extraDays = (d2.getTime() - anchor.getTime()) / (1000 * 60 * 60 * 24);
        total += Math.round((amount / 365) * extraDays);
      }
      return total;
    }
    return 0;
  }

  // Update amount when payingTill changes
  useEffect(() => {
    if (selectedFeeData && payingFrom && payingTill) {
      const amt = getProRataAmount(payingFrom, payingTill, selectedFeeData.durationType, selectedFeeData.amount);
      setDonationAmount(amt);
    }
  }, [payingFrom, payingTill, selectedFeeData]);

  return (
    <div
      className={` min-h-[70vh] ${isDarkMode ? "bg-globalBg" : "bg-[#ffff]"}`}
    >
      <div className="py-8 lg:mx-[320px] md:mx-0 ">
        <h2 className="text-center font-bold text-3xl text-blue-500 md:mb-3 ">
          Donation
        </h2>
        <p className={`px-2 ${isDarkMode ? "text-gray-500" : ""}`}>
          You can make a change by supporting our mission through your{" "}
          <b className={`${isDarkMode ? "text-white" : "text-black"}`}>
            Zakaat, Fitraat, Sadaqaat
          </b>{" "}
          and
          <b className={`${isDarkMode ? "text-white" : "text-black"}`}>
            {" "}
            Atiyat{" "}
          </b>{" "}
          in the world of digitalization.
        </p>

        {detailsMissing && (
          <>
            <UpdateUserDetails
              usermodalopen={detailsMissing}
              isDarkMode={isDarkMode}
              closeusermodal={handleCancelClick}
              url={url}
              userdetails={userProfile}
            />
          </>
        )}

        {modal && (
          <div
            className={`fixed inset-0 flex items-center justify-center ${isDarkMode
              ? "bg-gray-800 bg-opacity-90"
              : "bg-gray-500 bg-opacity-75"
              }`}
          >
            <div
              className={`p-6 rounded-lg shadow-lg w-full max-w-md border ${isDarkMode ? "bg-[#2e2e2e] border-gray-700 " : "bg-[#ffff]"
                }`}
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <div className="relative">
                <div className="absolute -top-10 right-0">
                  <button
                    onClick={() => {
                      setmodal(false)
                      handleResetForm();
                    }}
                    className={`text-3xl   ${isDarkMode
                      ? "text-gray-200 hover:text-gray-300"
                      : " text-gray-600  hover:text-gray-800"
                      }`}
                  >
                    &times;
                  </button>
                </div>
                <div className="text-center mb-8">
                  <h3
                    className={`mt-6 text-2xl font-bold ${
                      isDarkMode ? "text-white" : "text-[#1f3f75]"
                    }`}
                  >
                    Donation Detail
                  </h3>
                </div>
              </div>
              <label
                className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"
                  } `}
              >
                Donation Type*
                <select
                  required
                  className={`block w-full p-2 mt-1 border rounded  font-normal text-sm focus:outline-none ${isDarkMode
                    ? "border-gray-600 bg-gray-800 text-white  "
                    : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                    }`}
                  value={donationType?.value || donationOptions[0]?.value || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    const selectedType = donationOptions.find(
                      (option) => option.value === value);
                    if (selectedType) {
                      setDonationType(selectedType);
                      const defaultPurpose = getDefaultPurposeForType(selectedType.id);
                      setDonationPurpose(defaultPurpose);
                    }
                  }}
                >
                  {donationOptions.length === 0 && (
                    <option value="" disabled>
                      Select your option
                    </option>
                  )}
                  {donationOptions
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </select>
              </label>

              <label
                className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"
                  } `}
              >
                Donation Purpose*
                <select
                  required
                  className={`block w-full p-2 mt-1 rounded font-normal text-sm focus:outline-none border ${isDarkMode
                    ? "border-gray-600 bg-gray-800 text-white"
                    : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                    }`}
                  value={donationPurpose?.value || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    const selectedDTP = donationTP.filter((dtp) => dtp.donationTypeId === donationType?.id).find((dtp) => {
                      const taxonomyPurpose = donationPurposeOptions.find((p) => p.id === dtp.donationPurposeId);
                      return taxonomyPurpose?.value === value;
                    });
                    if (selectedDTP) {
                      const taxonomyPurpose = donationPurposeOptions.find((p) => p.id === selectedDTP.donationPurposeId);
                      if (taxonomyPurpose) {
                        setDonationPurpose({
                          value: taxonomyPurpose.value,
                          id: selectedDTP.donationPurposeId,
                          label: taxonomyPurpose.value
                        });
                      }
                    }
                  }}
                >
                  {getPurposesByDonationType(donationType?.id)
                    .map((item: any) =>
                      <option key={item.id} value={item.value}>
                        {item.label}
                      </option>
                    )}
                </select>
              </label>

              {donationType?.value === "Fees" &&
                donationPurpose?.value === "Online Classes" && (feeDetails.length > 0) && (
                  <>
                    <label
                      className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"}`}
                    >
                      Select Course
                      <select
                        required
                        className={`block w-full p-2 mt-1 border rounded font-normal text-sm focus:outline-none ${isDarkMode
                          ? "border-gray-600 bg-gray-800 text-white"
                          : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                          }`}
                        value={selectedFeeData?.id || ""}
                        onChange={(e) => handleSelectFee(e.target.value)}
                      >
                        <option value="" disabled>
                          Select Course
                        </option>
                        {feeDetails
                          .filter((fee) => {
                            if (editingIndex !== null && donations[editingIndex]?.fee?.typeId === fee.id) {
                              return true;
                            }
                            return !donations.some((donation) => donation.fee.typeId === fee.id);
                          })
                          .map((fee) => (
                            <option key={fee.id} value={fee.id}>
                              {fee.course} - {fee.courseType} - {fee.userName} - {fee.type}
                            </option>
                          ))}
                      </select>
                    </label>

                    {selectedFeeData && selectedFeeData.type == "Renewal" && (
                      <>
                        <div className="gap-4 mt-2">
                          <div>
                            <label className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"}`}>
                              Paying From
                            </label>
                            <input
                              type="date"
                              className={`block w-full p-2 mt-1 border rounded font-normal text-sm focus:outline-none ${isDarkMode
                                ? "border-gray-600 bg-gray-800 text-white"
                                : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                                }`}
                              value={selectedFeeData.paidTill?.slice(0, 10)}
                              disabled
                            />
                          </div>

                          <div className="mt-2">
                            <label className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"}`}>
                              Duration
                            </label>
                            <select
                              className={`block w-full p-2 mt-1 border rounded font-normal text-sm focus:outline-none ${isDarkMode
                                ? "border-gray-600 bg-gray-800 text-white"
                                : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                                }`}
                              value={payCount}
                              onChange={(e) => {
                                const count = parseInt(e.target.value);
                                setPayCount(count);

                                // Update paying till based on new duration
                                const fromDate = new Date(selectedFeeData.paidTill);
                                if (!isNaN(fromDate.getTime())) {
                                  const newTillDate = new Date(fromDate);
                                  if (selectedFeeData.durationType === "Monthly") {
                                    newTillDate.setMonth(newTillDate.getMonth() + count);
                                  } else if (selectedFeeData.durationType === "Yearly") {
                                    newTillDate.setFullYear(newTillDate.getFullYear() + count);
                                  }
                                  setPayingTill(newTillDate.toISOString().slice(0, 10));
                                }
                              }}
                            >
                              {[1, 2, 3, 4, 5, 6].map((num) => (
                                <option key={num} value={num}>
                                  {num}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="mt-2">
                            <label className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"}`}>
                              Paying Till
                            </label>
                            <input
                              type="date"
                              className={`block w-full p-2 mt-1 border rounded font-normal text-sm focus:outline-none ${isDarkMode
                                ? "border-gray-600 bg-gray-800 text-white"
                                : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                                }`}
                              value={payingTill}
                              min={
                                (() => {
                                  if (!selectedFeeData.paidTill) return "";
                                  const minDate = new Date(selectedFeeData.paidTill);
                                  if (isNaN(minDate.getTime())) return "";
                                  if (selectedFeeData.durationType === "Monthly") {
                                    minDate.setMonth(minDate.getMonth() + 1);
                                  } else if (selectedFeeData.durationType === "Yearly") {
                                    minDate.setFullYear(minDate.getFullYear() + 1);
                                  }
                                  return minDate.toISOString().slice(0, 10);
                                })()
                              }
                              onChange={(e) => {
                                const newDate = e.target.value;
                                setPayingTill(newDate);

                                // Calculate and update duration based on date difference
                                const fromDate = new Date(selectedFeeData.paidTill);
                                const tillDate = new Date(newDate);

                                if (!isNaN(fromDate.getTime()) && !isNaN(tillDate.getTime())) {
                                  if (selectedFeeData.durationType === "Monthly") {
                                    const months = (tillDate.getFullYear() - fromDate.getFullYear()) * 12
                                      + (tillDate.getMonth() - fromDate.getMonth());
                                    const days = tillDate.getDate() - fromDate.getDate();

                                    // If days are more than 15, round up to next month
                                    const adjustedMonths = days > 15 ? months + 1 : months;
                                    const clampedMonths = Math.min(Math.max(1, adjustedMonths), 6);
                                    setPayCount(clampedMonths);
                                  } else if (selectedFeeData.durationType === "Yearly") {
                                    const years = tillDate.getFullYear() - fromDate.getFullYear();
                                    const monthDiff = tillDate.getMonth() - fromDate.getMonth();
                                    const dayDiff = tillDate.getDate() - fromDate.getDate();

                                    // If more than 6 months or if exactly 6 months and more days, round up
                                    const adjustedYears = (monthDiff > 6 || (monthDiff === 6 && dayDiff > 0))
                                      ? years + 1 : years;
                                    const clampedYears = Math.min(Math.max(1, adjustedYears), 6);
                                    setPayCount(clampedYears);
                                  }
                                }
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

              <div>
                <label
                  className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"
                    } `}
                >
                  Donation Amount*
                </label>
                <input
                  disabled={selectedFeeData}
                  type="text"
                  className={`w-full p-2 border rounded-md text-sm font-normal focus:outline-none
                                     ${isDarkMode
                      ? "border-gray-600 bg-gray-800 text-white  "
                      : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                    }`}
                  value={donationAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    const amounts = value
                      .split(",")
                      .map((amount) => Number(amount.trim()))
                      .filter((amount) => !isNaN(amount));
                    setDonationAmount(Number(amounts));
                  }}
                />
              </div>


              <label
                className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"
                  } `}
              >
                On Behalf of*
                <select
                  required
                  className={`block w-full p-2 mt-1 border rounded font-normal text-sm focus:outline-none ${isDarkMode
                    ? "border-gray-600 bg-gray-800 text-white"
                    : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                    }`}
                  value={onBehalfof}
                  onChange={(e) => setOnBehalfof(e.target.value)}
                >
                  <option value="Self">Self</option>
                  <option value="Others">Others</option>
                </select>
              </label>

              {onBehalfof === "Others" && (
                <label
                  className={`block text-sm mt-2 font-semibold ${isDarkMode ? "text-white" : "text-black"
                    } `}
                >
                  Name*
                  <input
                    type="text"
                    className={`block w-full p-2 mt-1 border rounded focus:outline-none font-normal text-sm ${isDarkMode
                      ? "border-gray-600 bg-gray-800 text-white  "
                      : "border-gray-300 bg-white text-black focus:bg-gray-100 focus:border-blue-500"
                      }`}
                    value={onBehalfofName}
                    onChange={(e) => setOnBehalfofName(e.target.value)}
                  />
                </label>
              )}
              <button
                className=" text-left mt-4 px-3 py-2 text-sm font-semibold bg-blue-500 text-white rounded hover:bg-blue-600"
                onClick={handleSubmitClick}
              >
                Save
              </button>
            </div>
          </div>
        )}
        {donations.length !== 0 && (
          <div className="mb-5 mt-6">
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto border-collapse ">
                <thead>
                  <tr
                    className={`border-b  text-left  ${isDarkMode
                      ? " text-gray-300 border-gray-700"
                      : "text-black border-gray-300"
                      }`}
                  >
                    <th className="px-4 py-1 text-sm">Actions</th>
                    <th className="px-4 py-2 text-sm">Donation Type</th>
                    <th className="px-4 py-2 text-sm">Amount</th>
                    <th className="px-4 py-2 text-sm">Purpose</th>
                    <th className="px-4 py-2 text-sm">On Behalfof</th>
                    <th className="px-4 py-2 text-sm">On Behalfof Name</th>
                  </tr>
                </thead>
                <tbody>
                  {donations.map((donation, index) => (
                    <tr key={index}>
                      <td className="px-4 py-2 flex flex-row">
                        <button
                          className="mr-2 text-red-600 hover:text-red-800"
                          onClick={() => {
                            const newDonations = [...donations];
                            newDonations.splice(index, 1);
                            setDonations(newDonations);
                          }}
                        >
                          <IconTrash />
                        </button>
                        {renderEditButton(index)}
                      </td>
                      <td
                        className={`px-4 py-2 text-sm font-normal  ${isDarkMode ? " text-gray-300" : "text-black"
                          }`}
                      >
                        {donation.type}
                      </td>
                      <td
                        className={`px-4 py-2 text-sm font-normal  ${isDarkMode ? " text-gray-300" : "text-black"
                          }`}
                      >
                        {donation.amount}
                      </td>
                      <td
                        className={`px-4 py-2 text-sm font-normal  ${isDarkMode ? " text-gray-300" : "text-black"
                          }`}
                      >
                        {donation.purpose}
                      </td>
                      <td
                        className={`px-4 py-2 text-sm font-normal  ${isDarkMode ? " text-gray-300" : "text-black"
                          }`}
                      >
                        {donation.onBehalfof}
                      </td>
                      <td
                        className={`px-4 py-2 text-sm font-normal  ${isDarkMode ? " text-gray-300" : "text-black"
                          }`}
                      >
                        {donation.onBehalfofName}
                      </td>
                    </tr>
                  ))}
                  <tr
                    className={`${isDarkMode
                      ? " text-gray-300 border-t border-gray-700"
                      : "text-black border-t border-gray-300"
                      }`}
                  >
                    <td className="px-4 py-2"></td>
                    <td className="px-4 py-2 text-sm">Total</td>
                    <td className="px-4 py-2 text-sm">{totalAmount}</td>
                    <td className="px-4 py-2"></td>
                    <td className="px-4 py-2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className="flex flex-wrap items-center gap-4 mt-8 px-2">
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm font-semibold "
            onClick={handleAddDonationClick}
          >
            Add {donations.length > 0 ? "More" : "Donation"}
          </button>
          {donations.length > 0 && (
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded text-sm font-semibold  hover:bg-blue-600"
              onClick={donationEzpay}
            >
              Donate Now
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
export default DonationModal;
